module.exports = __webpack_public_path__ + "img/icon-white-66.74ba7127.svg";